import { ThreadToastContext, ThreadToastSettings } from '@/contexts/thread-toast/helpers';
import { useContext } from 'react';

const useThreadToast = () => useContext<ThreadToastSettings>(ThreadToastContext);

export default useThreadToast;
